import {combineLatestWith, map, of, switchMap} from 'rxjs';
import {browser$} from '@/streams/browser';
import {userStatus$} from '@/streams/auth';
import {skipUntil} from 'rxjs/operators';
import {announcementApi} from '@/api';
interface queryProps {
  itemKey: string;
  location: number;
  device: 'WEB';
  lang: string;
}

export function loadBanner(query: queryProps) {
  const banner$ = of(query).pipe(
    skipUntil(browser$),
    combineLatestWith(userStatus$),
    switchMap(([q, userStatus]) => (userStatus === 'Login' ? announcementApi.contentViewLogin(query) : announcementApi.contentViewLogout(query))),
    map((res) => {
      if (res.data) {
        return res.data.rows[0] || {};
      }
      return {};
    })
  );
  return {banner$};
}
